export function radonStatus(radon: number): {
  caption: string;
  title: string;
  value: string;
  progressValue: number;
} {
  switch (radon) {
    case 1:
      return {
        title: "Indoor Radon",
        value: "High",
        caption: "County average indoor radon levels",
        progressValue: 100,
      };
    case 2:
      return {
        title: "Indoor Radon",
        value: "Moderate",
        caption: "County average indoor radon levels",
        progressValue: 50,
      };
    case 3:
      return {
        title: "Indoor Radon",
        value: "Low",
        caption: "County average indoor radon levels",
        progressValue: 0,
      };
    default:
      return {
        title: "Indoor Radon",
        value: "N/A",
        caption: "County average indoor radon levels",
        progressValue: 0,
      };
  }
}
